var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 8.0001C9.76741 8.0001 11.2001 6.56741 11.2001 4.8001C11.2001 3.03279 9.76741 1.6001 8.0001 1.6001C6.23279 1.6001 4.8001 3.03279 4.8001 4.8001C4.8001 6.56741 6.23279 8.0001 8.0001 8.0001ZM3.36227 9.96647C2.14452 10.6194 1.6001 11.9764 1.6001 13.3581C1.6001 13.9336 2.06661 14.4001 2.64208 14.4001H13.3581C13.9336 14.4001 14.4001 13.9336 14.4001 13.3581C14.4001 11.9764 13.8557 10.6194 12.6379 9.96647C11.5402 9.37789 9.96273 8.8001 8.0001 8.8001C6.03746 8.8001 4.46002 9.37789 3.36227 9.96647Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.deb774cb8954086a95d408a0723d61e7.svg";
export { ForwardRef as ReactComponent };